import { useState, useEffect } from 'react';
import api from '../services/api';

/**
 * Fetch full projects list for resolving query.projectName → "name - description" display.
 * @param {boolean} enabled
 * @returns {Array<Object>} projects from API
 */
export const useProjectsCatalog = (enabled = true) => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    if (!enabled) {
      setProjects([]);
      return;
    }
    let ignore = false;
    (async () => {
      try {
        const response = await api.get('/projects', { params: { limit: 1000 } });
        const list =
          response.data?.data?.projects || response.data?.projects || [];
        if (!ignore) {
          setProjects(Array.isArray(list) ? list : []);
        }
      } catch {
        if (!ignore) setProjects([]);
      }
    })();
    return () => {
      ignore = true;
    };
  }, [enabled]);

  return projects;
};
